import Lightbox from './Lightbox'

export { useLightbox, LightboxProvider } from './useLightbox'

export default Lightbox
